module.exports = __webpack_public_path__ + "img/93143fa.jpg";